import { getWeekdayInitials, useTokenValues } from '@jds/react-engine';

import { createRows } from '../jdsdatepickerdesktop/dateLogic';
import { useMemo } from 'react';

export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    const { month, year, day } = props;
    const tokens = useTokenValues();
    const language = tokens.lang;
    const getWeekdayInitialsFromLocale = useMemo(() => {
      return getWeekdayInitials(language);
    }, [language]);

    const rows = createRows(
      month,
      year,
      day,
      props.disabled.disabledDates,
      props.disabled.dateFilter,
      props.selected,
      props.disabled?.min,
      props.disabled?.max
    );
    const selectedDate = props.selected;
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    };

    const dateWithoutTime: string = selectedDate.toLocaleDateString(
      'en-US',
      options
    );
    return (
      <Component
        {...{
          ...props,
          rows,
          dateAriaLabel: `Selected date ${dateWithoutTime}`,
          days: getWeekdayInitialsFromLocale.map((d) => ({ letter: d[0] }))
        }}
      />
    );
  };
